import React from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm } from 'redux-form';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import { loginLoadingSelector } from '../../../selectors/auth';
import { useAppWidthClass } from '../../../utils/hooks';

import { Paper, TextInput, ThemeButton } from '../../common';
import { WelcomeTitle } from '../Welcome';

import troy from '../../../assets/img/logos/troy/troy_login.png';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: '32px 16px',
    borderRadius: 24,
    boxSizing: 'border-box',
    boxShadow: theme.customShadows.login
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  logo: {
    width: 109,
    height: 48
  },
  welcome: {
    marginTop: 16
  },
  userName: {
    marginTop: 24,
    width: '100%'
  },
  password: {
    marginTop: 16,
    width: '100%'
  },
  button: {
    marginTop: 32
  }
}));

const LoginForm = ({ handleSubmit }) => {
  const classes = useStyles();
  const { isMobileWidth } = useAppWidthClass();

  const isLoading = useSelector(loginLoadingSelector);

  return (
    <Paper className={classes.root}>
      <Form className={classes.form} onSubmit={handleSubmit}>
        <img src={troy} alt="troy-logo" className={classes.logo} />
        {isMobileWidth && (
          <WelcomeTitle className={classes.welcome} isMobileWidth />
        )}
        <TextInput
          labelFixed
          required
          id="login-form-username"
          className={classes.userName}
          name="username"
          placeholder="LOGIN"
          inputPlaceholder="1234567890"
          startIcon="profile"
        />
        <TextInput
          labelFixed
          required
          id="login-form-password"
          className={classes.password}
          name="password"
          type="password"
          placeholder="PASSWORD"
          inputPlaceholder="12345"
          startIcon="key"
        />
        <ThemeButton
          hasAnimation
          className={classes.button}
          id="page.login.component.login-form.login-button"
          type="submit"
          variant="contained"
          textKey="LOGIN"
          isLoading={isLoading}
        />
      </Form>
    </Paper>
  );
};

LoginForm.propTypes = {
  handleSubmit: PropTypes.func
};

const LoginReduxForm = reduxForm({ form: 'login' })(LoginForm);

export default LoginReduxForm;
